import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { darkTheme } from "../../../styles/styles";
import { PendingTable } from "./PendingTable";

const Pending = () => {

  return (
    <ThemeProvider theme={darkTheme}>
        <Box sx={{ width: "100%" }}>
            <Box>
                <PendingTable />
            </Box>
        </Box>
    </ThemeProvider>
  );
};


export default Pending;
